module.exports = __webpack_public_path__ + "img/w58b.2a7304d9.jpg";